import script from "./SellerSettlementsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerSettlementsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerSettlementsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__